export const labels = {
  total: 'Total',
  completeProfiles: 'Complete Profiles',
  hired: 'Hired',
  all: 'All',
  talent: 'Talent',
  client: 'Client',
  completed: 'Completed',
  incomplete: 'Incomplete',
  profile: 'Profile',
  affiliate: 'Affiliate',
  hiringStatus: 'Hiring Status',
  specialization: 'Specialization',
  userType: 'User Type',
  country: 'Country',
  unspecified: 'Unspecified',
};
